import React, { Component } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import axios from "axios"
import { connect } from "react-redux"
import config from "config/config"

class MonthlyEarnings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      options: {
        chart: {
          type: "bar", // Bar chart
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true, // Horizontal bars
          },
        },
        dataLabels: {
          enabled: false, // Disable data labels for cleaner UI
        },
        xaxis: {
          categories: [], // Country names will be populated dynamically
          title: {
            text: "Countries",
          },
        },
        yaxis: {
          title: {
            text: "Interactions",
          },
        },
        tooltip: {
          y: {
            formatter: val => `${val} interactions`,
          },
        },
        colors: ["#2990DF"], // Customize bar color
        grid: {
          borderColor: "#f1f1f1",
        },
      },
      series: [
        {
          name: "Country Metrics",
          data: [], // Metrics will be populated dynamically
        },
      ],
    }
  }

  componentDidMount() {
    this.fetchAnalyticsData()
  }

  fetchAnalyticsData = async () => {
    try {
      const { activeOrganization } = this.props
      const analyticsData = activeOrganization?.GoogleAnalyticsIntegrations[0]

      if (!analyticsData) {
        console.error("No Google Analytics Integration found")
        return
      }

      // Fetch data from the Google Analytics API
      const response = await axios.get(
        `${config.backendUrl}/analytics/getReport?accessToken=${analyticsData.accessToken}&propertyId=${analyticsData.propertyId}&accountId=${analyticsData.accountId}`,
      )

      const data = response.data

      // Aggregate data by country
      const countryMetrics = {}

      data.rows.forEach(row => {
        const country = row.dimensionValues[0]?.value || "Unknown"
        const interactions = Number(row.metricValues[0]?.value || 0)

        countryMetrics[country] = (countryMetrics[country] || 0) + interactions
      })

      // Prepare data for the chart
      const countries = Object.keys(countryMetrics)
      const metrics = Object.values(countryMetrics)

      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: countries,
          },
        },
        series: [
          {
            name: "Country Metrics",
            data: metrics,
          },
        ],
      })
    } catch (error) {
      console.error("Error fetching Google Analytics data:", error)
    }
  }

  render() {
    return (
      <React.Fragment>
        <Card className="br">
          <CardBody>
            <h4 className="card-title mb-4">Country Metrics Overview</h4>

            <div
              id="country-metrics-graph"
              className="chart-container"
              dir="ltr"
            >
              <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="bar"
                height="1500"
              />
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  activeOrganization: state.organizationReducer.activeOrganization,
})

export default connect(mapStateToProps)(MonthlyEarnings)
